import _regeneratorRuntime from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { cloneAudioWorkletNodeOptions } from './clone-audio-worklet-node-options';
export var createAudioWorkletProcessorPromise = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(processorConstructor, audioWorkletNodeOptions) {
    var clonedAudioWorkletNodeOptions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return cloneAudioWorkletNodeOptions(audioWorkletNodeOptions);

          case 2:
            clonedAudioWorkletNodeOptions = _context.sent;
            return _context.abrupt("return", new processorConstructor(clonedAudioWorkletNodeOptions));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createAudioWorkletProcessorPromise(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();